var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.63063 0C2.97674 0 0 2.9767 0 6.63054C0 10.2844 2.97674 13.2611 6.63063 13.2611C7.79516 13.2611 8.89341 12.9626 9.84586 12.4323L12.8825 15.4689C13.5906 16.177 14.7609 16.177 15.4689 15.4689C16.177 14.7609 16.177 13.5906 15.4689 12.8826L12.4323 9.84594C12.9624 8.89346 13.2611 7.7951 13.2611 6.63075C13.2611 2.97691 10.2843 0.000203967 6.63043 0.000203967L6.63063 0ZM6.63063 1.37178C9.54309 1.37178 11.8894 3.71804 11.8894 6.6305C11.8894 9.5428 9.54313 11.8892 6.63063 11.8892C3.71813 11.8892 1.37184 9.54296 1.37184 6.6305C1.37184 3.71804 3.71813 1.37178 6.63063 1.37178ZM11.6249 10.9819L14.4972 13.8541C14.6847 14.0416 14.6847 14.3096 14.4972 14.4972C14.3097 14.6847 14.0417 14.6847 13.8542 14.4972L10.9819 11.6249C11.2107 11.4253 11.4253 11.2107 11.6249 10.9819Z",
    fill: "#8566E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.e06623b6db87f4228d4b34dab79f2681.svg";
export { ForwardRef as ReactComponent };